export default __webpack_public_path__ + "static/media/My schedule 1.372d2e01.png";